<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <h4 class="mb-4">User Setup</h4>
                            <div class="panelDiv">
                                <div class="col-sm-12 mb-4">
                                    <div class="dashboardApplication">
                                        <button class="btn btn-primary btn-MinWidth " v-on:click="NavigationRoute('userCreation','admin')">User Creation</button>
                                    </div>
                                </div>
                            </div>
                            <div v-for="(appdetails, index) in AppList.applications" v-bind:key="index.id">
                                <div class="col-sm-12 p-0 m-0 row mb-2 mt-1"></div>
                                <h4 class="mb-4">{{appdetails.name}}</h4>
                                <div class="panelDiv">
                                    <div class="col-sm-12 mb-4">
                                        <div v-if="appdetails.appKey=='BRC'">
                                            <div class="dashboardApplication">
                                                <button class="btn btn-primary btn-MinWidth" v-bind:id="'btn' + appdetails.id" v-on:click="NavigationRoute(appdetails.appKey,'admin',appdetails)">Bank Client Mapping</button>
                                            </div>
                                            <div class="dashboardApplication">
                                                <button class="btn btn-primary btn-MinWidth" v-on:click="NavigationRoute('adminHeaders','admin',appdetails)">Header Configuration</button>
                                            </div>
                                            <div class="dashboardApplication">
                                                <button class="btn btn-primary btn-MinWidth" v-on:click="NavigationRoute('businessRules','admin',appdetails)">Business Rules</button>
                                            </div>
                                            <div class="dashboardApplication">
                                                <button class="btn btn-primary btn-MinWidth" v-on:click="NavigationRoute('acrReport','admin',appdetails)">Reports</button>
                                            </div>
                                        </div>
                                        <div v-if="appdetails.appKey=='MEMO'">
                                            <div class="dashboardApplication">
                                                <button class="btn btn-primary btn-MinWidth" v-bind:id="'btn' + appdetails.id" v-on:click="NavigationRoute(appdetails.appKey,'admin',appdetails)">Memo History</button>
                                            </div>
                                            <div class="dashboardApplication">
                                                <button class="btn btn-primary btn-MinWidth" v-on:click="NavigationRoute('adminHeaders','admin',appdetails)">Header Configuration</button>
                                            </div>
                                        </div>
                                        <div v-if="appdetails.appKey=='USBRGAAP'">
                                            <div class="dashboardApplication">
                                                <button class="btn btn-primary btn-MinWidth" v-on:click="NavigationRoute('adminHeaders','admin',appdetails)">Header Configuration</button>
                                            </div>
                                        </div>
                                        <div v-if="appdetails.appKey=='CIT'">
                                            <div class="dashboardApplication">
                                                <button v-if="appdetails.appKey=='CIT'" class="btn btn-primary btn-MinWidth" v-on:click="NavigationRoute('adminHeaders','admin',appdetails)">Header Configuration</button>
                                            </div>
                                            <div class="dashboardApplication">
                                                <button class="btn btn-primary btn-MinWidth" v-on:click="NavigationRoute('citReport','admin',appdetails)">Reports</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2 ">
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import LoginService from '../../services/login.service.js';
    import Navigation from '../../services/navigation.js';
    export default {
        name: 'AdminDashboard',
        data() {
            return {
                AppList: []
            }
        },
        mixins: [LoginService, Navigation],
        created() {
            this.getUserInfo();
        },
        methods: {
            getUserInfo() {
                this.AppList = JSON.parse(sessionStorage.getItem('appList'));
            }
        }
    }
</script>